import { render, staticRenderFns } from "./CarouselBase.vue?vue&type=template&id=d605622c"
import script from "./CarouselBase.vue?vue&type=script&lang=js"
export * from "./CarouselBase.vue?vue&type=script&lang=js"
import style0 from "./CarouselBase.vue?vue&type=style&index=0&id=d605622c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports